import { Sun, Moon } from 'lucide-react';

interface ThemeToggleProps {
  isDarkMode: boolean;
  onToggle: () => void;
  isCollapsed?: boolean;
}

export default function ThemeToggle({ isDarkMode, onToggle, isCollapsed }: ThemeToggleProps) {
  return (
    <button
      onClick={onToggle}
      className="flex w-full items-center justify-center space-x-2 rounded-lg px-3 py-2.5 text-navy-600 hover:bg-navy-100 hover:text-accent-500 dark:text-navy-300 dark:hover:bg-navy-800 dark:hover:text-accent-400 transition-all duration-200"
    >
      {isDarkMode ? (
        <>
          <Sun className="h-5 w-5 text-accent-400" />
          {!isCollapsed && <span>Modo Claro</span>}
        </>
      ) : (
        <>
          <Moon className="h-5 w-5" />
          {!isCollapsed && <span>Modo Escuro</span>}
        </>
      )}
    </button>
  );
}
